import React from 'react';
import Dropdown from 'react-dropdown';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
// import DatePicker from 'react-datepicker';


const dsplType = [
  { value: '0', label: 'All pages' },
  { value: '1', label: 'Custom' },
];

const displayRule = [
  { value: '2', label: 'Contains' },
  { value: '1', label: 'Equals' },
  { value: '3', label: 'Regex' },
  { value: '5', label: 'Does not contain' },
  { value: '4', label: 'Does not equal' },
  { value: '6', label: 'Does not Regex' }
];

const visitorType = [
  { value: '0', label: 'All' },
  { value: '1', label: 'New Visitor' },
  { value: '2', label: 'Returning Visitor' }
];

const utmType = [
  { value: '0', label: 'Contains' },
  { value: '1', label: 'Exclude' },
];

const cookieType = [
  { value: '0', label: 'Exact' },
  { value: '1', label: 'Not Exact' },
  { value: '2', label: 'Contains' },
  { value: '3', label: 'Not Contains' },
];

const referralType = [
  { value: '2', label: 'Contains' },
  { value: '0', label: 'Exact' },
  { value: '1', label: 'Not Exact' },
  { value: '3', label: 'Not Contains' },
];

const ChatDisplayRuleCard = ({
  handleChkArray,
  onChangeUpdateWidget,
  state,
  handleInputchange,
  DisplayValidator,
  DisplayUTMValidator,
  cookieValidator,
  ReferralValidator,
  removeDisplayRule,
  handleWidgetChange,
  handleTabchange
}) => {
  let widgetById = state.widgetById;
  return (
    <div className="side-editor-panel side-editor-layout">
      <Tabs className="nf-default-tabs wg-default-editor">
        <TabList className="wg-tabs-secstyle wg-tabs-appearance">
          <div className="sidebar-aniborder-block" id="Wdgt-Tab-displayRule"></div>
          <Tab onClick={() => handleTabchange('display', 'displayRule')}>Display</Tab>
          <Tab onClick={() => handleTabchange('segmentation', 'displayRule')}>Segmentation</Tab>
          <Tab onClick={() => handleTabchange('behaviour', 'displayRule')}>Behaviour</Tab>
        </TabList>
        <TabPanel className="tabs-secstyle-panel tabs-panel-displayrule">
          <div className="card card-editor card-template mt-15">
            <div className="card-editor-block p-0">
              <label className="card-editor-title">Display on pages</label>
              <div className="customize-list">
                <div className="editor-dropdown customize-dropdown customize-coloms">
                  <label>Display Type</label>
                  <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={dsplType} value={widgetById.dspltyp != undefined ? widgetById.dspltyp.toString() : widgetById.dspltyp} onChange={(e) => handleWidgetChange('dspltyp', e.value)} />
                </div>
                {widgetById.dspltyp != '0' &&
                  <div>
                    <div className="editor-toggle customize-dropdown customize-showarrow">
                      <label className="label-title">Absolute URL</label>
                      <label className="switch">
                        <input type="checkbox" checked={widgetById.dabs} onChange={(e) => handleWidgetChange('dabs', e.target.checked)} />
                        <span className="slider round"></span>
                      </label>
                    </div>
                    <div className="editor-dropdown customize-dropdown customize-coloms editor-rowbdr-none editor-dropdown-condition validation-text-box">
                      <label>Condition</label>
                      <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={displayRule} value={state.dt != undefined ? state.dt.toString() : state.dt} onChange={(e) => handleInputchange('dt', e.value)} />
                      {DisplayValidator.message('Condition', state.dt, 'required')}
                    </div>
                    <div className="editor-input header-editor-ckeditor editor-header-caption  editor-rowbdr-none mt-0">
                      <label className="label-title">Enter the URL</label>
                      <div className="editor-inputbtn editor-enter-url">
                        <input className="editor-input-content editor-input-fullwidth editor-input-exdke" type="text" value={state.ul} onChange={(e) => handleInputchange('ul', e.target.value)}></input>
                        <input className="nf-btn nf-btn-default" type='button' value='Add' onClick={() => onChangeUpdateWidget('dsplurl')} />
                      </div>
                      {DisplayValidator.message('Url', state.ul, 'required')}
                      <div className="table-urladd-block">
                        <table className="table table-sm-font tbl-middle-text tbl-header-bg tbl-th-bordernone tbl-include-url">
                          <thead>
                            <tr>
                              <th>Condition</th>
                              <th>Data</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {widgetById.dsplurl && widgetById.dsplurl.length > 0 ?
                              widgetById.dsplurl.map((val, key) => {
                                let dRule = displayRule.filter(x => x.value == val.dt)[0].label;
                                return (
                                  <tr key={key}>
                                    <td>{dRule}</td>
                                    <td className="tbl-urltd">{val.ul}</td>
                                    <td className="url-del-right">
                                      <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt" onClick={() => removeDisplayRule('dsplurl', val._id)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                                          <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                                            <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                                            <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                                          </g>
                                        </svg>
                                      </span>
                                    </td>
                                  </tr>
                                );
                              })
                              :
                              <tr>
                                <td className="text-center" colSpan="3"><p className="norecord-text">No record found</p></td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </TabPanel>
        <TabPanel className="tabs-secstyle-panel tabs-panel-segmentation">
          <div className="card card-editor card-template mt-15">
            {/* Returning or new visitors */}
            <div className="card-editor-block p-0 card-editor-tgldflclose card-editor-rtrnvst">
              <div className="editor-field-list card-editor-titletgl">
                <label className="card-editor-title">Returning or new visitors</label>
                <label className="switch">
                  <input type="checkbox" checked={widgetById.irtnvstr} onChange={(e) => handleWidgetChange('irtnvstr', e.target.checked)} />
                  <span className="slider round"></span>
                </label>
              </div>
              {widgetById.irtnvstr == true &&
                <div className="customize-list">
                  <div className="editor-field-list editor-dropdown customize-dropdown customize-coloms dropdown-returvisitor">
                    <label>Visitors</label>
                    <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={visitorType} value={widgetById.rtncnd != undefined ? widgetById.rtncnd.toString() : widgetById.rtncnd} onChange={(e) => handleWidgetChange('rtncnd', e.value)} />
                  </div>
                </div>
              }
            </div>
            {/* UTM based display */}
            <div className="card-editor-block p-0  card-editor-tgldflclose card-editor-whatsutmdis">
              <div className="editor-field-list card-editor-titletgl">
                <label className="card-editor-title">UTM based display</label>
                <label className="switch">
                  <input type="checkbox" checked={widgetById.iutmdspl} onChange={(e) => handleWidgetChange('iutmdspl', e.target.checked)} />
                  <span className="slider round"></span>
                </label>
              </div>
              {widgetById.iutmdspl == true &&
                <div className="customize-list">
                  <div className="editor-field-list editor-dropdown customize-dropdown customize-coloms editor-rowbdr-none validation-text-box">
                    <label>Condition</label>
                    <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={utmType} value={state.utmCnd != undefined ? state.utmCnd.toString() : state.utmCnd} onChange={(e) => handleInputchange('utmCnd', e.value)} />
                    {DisplayUTMValidator.message('Condition', state.utmCnd, 'required')}
                  </div>
                  <div className="editor-field-list editor-input header-editor-ckeditor editor-header-caption editor-rowbdr-btm mt-0">
                    <label className="label-title">Enter data</label>
                    <div className="editor-inputbtn editor-enter-url">
                      <input className="editor-input-content editor-input-fullwidth editor-input-exdke" type="text" value={state.utmTxt} onChange={(e) => handleInputchange('utmTxt', e.target.value)}></input>
                      <input className="nf-btn nf-btn-default" type='button' value='Add' onClick={() => onChangeUpdateWidget('utmcnd')} />
                    </div>
                  </div>
                  {DisplayUTMValidator.message('data', state.utmTxt, 'required')}
                  <div className="table-urladd-block table-enterdata-block ">
                    <table className="table table-sm-font tbl-middle-text tbl-header-bg tbl-th-bordernone tbl-include-url">
                      <thead>
                        <tr>
                          <th>Condition</th>
                          <th>Data</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          widgetById.utmcnd && widgetById.utmcnd.length > 0 ?
                            widgetById.utmcnd.map((val, key) => {
                              let utm = utmType.filter(x => x.value == val.cnd)[0].label;
                              return (
                                <tr key={key}>
                                  <td>{utm}</td>
                                  <td className="tbl-urltd">{val.txt}</td>
                                  <td className="url-del-right">
                                    <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt" onClick={() => removeDisplayRule('utmcnd', val._id)}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                                        <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                                          <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                                          <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                                        </g>
                                      </svg>
                                    </span>
                                  </td>
                                </tr>
                              );
                            })
                            :
                            <tr>
                              <td className="text-center" colSpan="3"><p className="norecord-text">No record found</p></td>
                            </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              }
            </div>

            {/* Based on cookies name  */}
            <div className="card-editor-block p-0  card-editor-tgldflclose card-editor-whatsbscookie">
              <div className="editor-field-list card-editor-titletgl">
                <label className="card-editor-title">Based on cookies</label>
                <label className="switch">
                  <input type="checkbox" checked={widgetById.ibcks} onChange={(e) => handleWidgetChange('ibcks', e.target.checked)} />
                  <span className="slider round"></span>
                </label>
              </div>
              {widgetById.ibcks &&
                <div className="customize-list">
                  <div className="editor-field-list editor-dropdown customize-dropdown customize-coloms editor-rowbdr-none validation-text-box">
                    <label>Condition</label>
                    <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={cookieType} value={state.ckeCnd != undefined ? state.ckeCnd.toString() : state.ckeCnd} onChange={(e) => handleInputchange('ckeCnd', e.value)} />
                    {cookieValidator.message('Condition', state.ckeCnd, 'required')}
                  </div>
                  <div className="editor-input header-editor-ckeditor editor-header-caption editor-rowbdr-btm mt-0">
                    <label className="label-title">Enter data</label>
                    <div className="editor-inputbtn editor-enter-url">
                      <input className="editor-input-content editor-input-fullwidth editor-input-exdke" type="text" value={state.ckeTxt} onChange={(e) => handleInputchange('ckeTxt', e.target.value)}></input>

                      <input className="nf-btn nf-btn-default" type='button' value='Add' onClick={() => onChangeUpdateWidget('bckscnd')} />
                    </div>
                  </div>
                  {cookieValidator.message('data', state.ckeTxt, 'required')}
                  <div className="table-urladd-block table-enterdata-block">
                    <table className="table table-sm-font tbl-middle-text tbl-header-bg tbl-th-bordernone tbl-include-url">
                      <thead>
                        <tr>
                          <th>Condition</th>
                          <th>Data</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {widgetById.bckscnd && widgetById.bckscnd.length > 0 ?
                          widgetById.bckscnd.map((val, key) => {
                            let Ctype = cookieType.filter(x => x.value == val.cnd)[0].label;
                            return (
                              <tr key={key}>
                                <td>{Ctype}</td>
                                <td className="tbl-urltd">{val.txt}</td>
                                <td className="url-del-right">
                                  <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt" onClick={() => removeDisplayRule('bckscnd', val._id)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                                      <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                                        <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                                        <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                                      </g>
                                    </svg>
                                  </span>
                                </td>
                              </tr>
                            );
                          })
                          :
                          <tr>
                            <td className="text-center" colSpan="3"><p className="norecord-text">No record found</p></td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              }
            </div>

            {/* Referrer site */}
            <div className="card-editor-block p-0 card-editor-tgldflclose card-editor-rfrsite">
              <div className="editor-field-list card-editor-titletgl">
                <label className="card-editor-title">Referrer site</label>
                <label className="switch">
                  <input type="checkbox" checked={widgetById.irffrm} onChange={(e) => handleWidgetChange('irffrm', e.target.checked)} />
                  <span className="slider round"></span>
                </label>
              </div>
              {widgetById.irffrm &&
                <div className="customize-list">
                  <div className="editor-field-list editor-dropdown customize-dropdown customize-coloms  validation-text-box">
                    <label>Condition</label>
                    <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={referralType} value={state.refCnd != undefined ? state.refCnd.toString() : state.refCnd} onChange={(e) => handleInputchange('refCnd', e.value)} />
                    {ReferralValidator.message('Condition', state.refCnd, 'required')}
                  </div>
                  <div className="editor-input header-editor-ckeditor editor-header-caption  mt-0">
                    <label className="label-title">Enter data</label>
                    <div className="editor-inputbtn editor-enter-url">
                      <input className="editor-input-content editor-input-fullwidth editor-input-exdke" type="text" value={state.refTxt} onChange={(e) => handleInputchange('refTxt', e.target.value)}></input>

                      <input className="nf-btn nf-btn-default" type='button' value='Add' onClick={() => onChangeUpdateWidget('rfcnd')} />
                    </div>
                  </div>
                  {ReferralValidator.message('data', state.refTxt, 'required')}
                  <div className="table-urladd-block table-enterdata-block">
                    <table className="table table-sm-font tbl-middle-text tbl-header-bg tbl-th-bordernone tbl-include-url">
                      <thead>
                        <tr>
                          <th>Condition</th>
                          <th>Data</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {widgetById.rfcnd && widgetById.rfcnd.length > 0 ?
                          widgetById.rfcnd.map((val, key) => {
                            let rtype = cookieType.filter(x => x.value == val.cnd)[0].label;
                            return (
                              <tr key={key}>
                                <td>{rtype}</td>
                                <td className="tbl-urltd">{val.txt}</td>
                                <td className="url-del-right">
                                  <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt" onClick={() => removeDisplayRule('rfcnd', val._id)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                                      <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                                        <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                                        <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                                      </g>
                                    </svg>
                                  </span>
                                </td>
                              </tr>
                            );
                          })
                          :
                          <tr>
                            <td className="text-center" colSpan="3"><p className="norecord-text">No record found</p></td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              }
            </div>
          </div>
        </TabPanel>
        <TabPanel className="tabs-secstyle-panel tabs-panel-behaviour">
          <div className="card card-editor card-template mt-15">
            <div className="card-editor-block p-0">
              <label className="card-editor-title">Behaviour rule</label>
              <div className="customize-list">
                <div className="editor-field-list editor-input editor-input-label editor-enter-date editor-enter-datest">
                  <label className="label-title">Start date</label>
                  <div className="editor-inputbtn editor-enter-datepk ">
                    {/* <DatePicker
                      selected={widgetById.frmdt ? new Date(widgetById.frmdt) : null}
                      onChange={date => handleWidgetChange('frmdt', date)}
                      className={'editor-input-content editor-input-fullwidth '}
                      showTimeSelect
                      dateFormat="dd/MMM/yyyy h:mm aa" /> */}
                  </div>
                </div>
                <div className="editor-field-list editor-input editor-input-label editor-enter-date editor-enter-datest">
                  <label className="label-title">End date</label>
                  <div className="editor-inputbtn editor-enter-datepk ">
                    {/* <DatePicker
                      selected={widgetById.expdt ? new Date(widgetById.expdt) : null}
                      onChange={date => handleWidgetChange('expdt', date)}
                      className={'editor-input-content editor-input-fullwidth '}
                      showTimeSelect
                      dateFormat="dd/MMM/yyyy h:mm aa" /> */}
                  </div>
                </div>
                <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
                  <label className="label-title">Schedule on specific days</label>
                  <label className="switch">
                    <input type="checkbox" checked={widgetById.irptdy} onChange={(e) => handleWidgetChange('irptdy', e.target.checked)} />
                    <span className="slider round"></span>
                  </label>
                </div>
                {widgetById.irptdy == true &&
                  <div>
                    <div className="editor-day-block">
                      <div className="editor-day-item editor-day-sun">
                        <input type="checkbox" defaultChecked={widgetById.arrptdy ? widgetById.arrptdy.includes('0') : false} onChange={(e) => handleChkArray('0', e.target.checked)} />
                        <label className="light-label">Sun</label>
                      </div>
                      <div className="editor-day-item editor-day-mon">
                        <input type="checkbox" defaultChecked={widgetById.arrptdy ? widgetById.arrptdy.includes('1') : false} onChange={(e) => handleChkArray('1', e.target.checked)} />
                        <label className="light-label">Mon</label>
                      </div>
                      <div className="editor-day-item editor-day-tue">
                        <input type="checkbox" defaultChecked={widgetById.arrptdy ? widgetById.arrptdy.includes('2') : false} onChange={(e) => handleChkArray('2', e.target.checked)} />
                        <label className="light-label">Tue</label>
                      </div>
                      <div className="editor-day-item editor-day-wed">
                        <input type="checkbox" defaultChecked={widgetById.arrptdy ? widgetById.arrptdy.includes('3') : false} onChange={(e) => handleChkArray('3', e.target.checked)} />
                        <label className="light-label">Wed</label>
                      </div>
                      <div className="editor-day-item editor-day-thrd">
                        <input type="checkbox" defaultChecked={widgetById.arrptdy ? widgetById.arrptdy.includes('4') : false} onChange={(e) => handleChkArray('4', e.target.checked)} />
                        <label className="light-label">Thrd</label>
                      </div>
                      <div className="editor-day-item editor-day-fri">
                        <input type="checkbox" defaultChecked={widgetById.arrptdy ? widgetById.arrptdy.includes('5') : false} onChange={(e) => handleChkArray('5', e.target.checked)} />
                        <label className="light-label">Fri</label>
                      </div>
                      <div className="editor-day-item editor-day-sat">
                        <input type="checkbox" defaultChecked={widgetById.arrptdy ? widgetById.arrptdy.includes('6') : false} onChange={(e) => handleChkArray('6', e.target.checked)} />
                        <label className="light-label">Sat</label>
                      </div>
                    </div>
                    <div className="editor-input editor-input-label editor-enter-date editor-enter-datest">
                      <label className="label-title">Select start time</label>
                      <div className="editor-inputbtn editor-enter-datepk ">
                        {/* <DatePicker
                          selected={widgetById.rptstm ? new Date(widgetById.rptstm) : null}
                          onChange={date => handleWidgetChange('rptstm', date)}
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={5}
                          className={'editor-input-content editor-input-fullwidth '}
                          timeCaption="Time"
                          dateFormat="h:mm aa" /> */}
                      </div>
                    </div>
                    <div className="editor-input editor-input-label editor-enter-date editor-enter-datest">
                      <label className="label-title">Select end time</label>
                      <div className="editor-inputbtn editor-enter-datepk ">
                        {/* <DatePicker
                          selected={widgetById.rptetm ? new Date(widgetById.rptetm) : null}
                          onChange={date => handleWidgetChange('rptetm', date)}
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={5}
                          className={'editor-input-content editor-input-fullwidth '}
                          timeCaption="Time"
                          dateFormat="h:mm aa" /> */}
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <div className="card card-editor card-template mt-15">
            <div className="card-editor-block p-0">
              <label className="card-editor-title">Display rule</label>
              <div className="customize-list">
                <div className="editor-field-list card-editor-row card-editor-disrule card-editor-exitint">
                  <label className="radio label-nrm">
                    <input type='radio' value={1} checked={widgetById.bhvtyp == 1} onChange={(e) => handleWidgetChange('bhvtyp', e.target.value)} />
                    <span className="checkround"></span>
                    <span className="radio-label"> Exit intent </span>
                  </label>
                </div>
                <div className="editor-field-list card-editor-row card-editor-disrule card-editor-showafter">
                  <label className="radio label-nrm">
                    <input type='radio' value={2} checked={widgetById.bhvtyp == 2} onChange={(e) => handleWidgetChange('bhvtyp', e.target.value)} />
                    <span className="checkround"></span>
                    <span className="radio-label">Show after <span className="text-primary">{widgetById.dsplafttm}</span> second</span>
                  </label>
                  {widgetById.bhvtyp == 2 &&
                    <div className='nf-group-input nf-group-textinput'>
                      <div className='input-stgbtm-block'>
                        <input type='number' className='nf-input nf-input-sm' onChange={(e) => handleWidgetChange('dsplafttm', e.target.value)} value={widgetById.dsplafttm} />
                      </div>
                    </div>
                  }
                </div>
                <div className="editor-field-list card-editor-row card-editor-disrule card-editor-showafsrl">
                  <label className="radio label-nrm">
                    <input type='radio' value={3} checked={widgetById.bhvtyp == 3} onChange={(e) => handleWidgetChange('bhvtyp', e.target.value)} />
                    <span className="checkround"></span>
                    <span className="radio-label">Show after <span className="text-primary"> {widgetById.dsplaftscrl} </span> % scroll </span>
                  </label>
                  {widgetById.bhvtyp == 3 &&
                    <div className='nf-group-input nf-group-textinput'>
                      <div className='input-stgbtm-block'>
                        <input type='number' className='nf-input nf-input-sm' onChange={(e) => handleWidgetChange('dsplaftscrl', e.target.value)} value={widgetById.dsplaftscrl} />
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default ChatDisplayRuleCard;


// WEBPACK FOOTER //
// ./src/components/Widget/ChatDisplayRuleCard.js